import {ArticleImage} from '../types/graphql';

export default function articleImage(image: Partial<ArticleImage>): ArticleImage {
  return {
    caption: null,
    main: null,
    xlarge: null,
    large: null,
    medium: null,
    small: null,
    xsmall: null,
    ...image,
  }
}